/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponseUserAccountEntity } from '../../models/api-response-user-account-entity';

export interface UpdateLastLogin$Params {
  'x-api-requestId': string;
  'x-api-canal': string;
      body: string
}

export function updateLastLogin(http: HttpClient, rootUrl: string, params: UpdateLastLogin$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseUserAccountEntity>> {
  const rb = new RequestBuilder(rootUrl, updateLastLogin.PATH, 'post');
  if (params) {
    rb.header('x-api-requestId', params['x-api-requestId'], {});
    rb.header('x-api-canal', params['x-api-canal'], {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponseUserAccountEntity>;
    })
  );
}

updateLastLogin.PATH = '/v1/api/user-api/update/last-login';
